import { useTranslation } from 'react-i18next';
import { Button } from '../../inputs/button.component';
import { CommonGlobalService } from '@umanforge/common';

interface BodyConfirmModalProps {
  children?: JSX.Element;
  confirmText?: string;
  cancelText?: string;
  canConfirm?: boolean;
  confirmColor?: string;
  confirmColorHover?: string;
  cancelColor?: string;
  cancelColorHover?: string;
  onCancel: () => void
  onConfirm: () => void;
}


export function BodyConfirmModal( { children, canConfirm, onConfirm, onCancel, confirmText, cancelText, confirmColor = '#f84141', confirmColorHover = '#ef4444', cancelColor = '#FFFFFF', cancelColorHover = '#F4F4F4' }: BodyConfirmModalProps ) {

  const { t } = useTranslation();

  return (
    <>
      <>
        { children }
      </>
      <div className='flex justify-end items-center w-full mt-4'>
        <div className='w-[30%]'>
          <Button
            color={ cancelColor }
            colorHover={ cancelColorHover }
            textColor={ CommonGlobalService.getTextColor( cancelColor ) === 'black' ? '#000' : '#fff' }
            borderColor='#D9D9D9'
            label={ cancelText ?? t( 'Cancel' ) }
            onClick={ onCancel }
          />
        </div>
        <div className='w-[30%]'>
          <Button
            disable={ canConfirm }
            color={ confirmColor }
            colorHover={ confirmColorHover }
            textColor={ CommonGlobalService.getTextColor( confirmColor ) === 'black' ? '#000' : '#fff' }
            borderColor='#D9D9D9'
            label={ confirmText ?? t( 'Confirm' ) }
            onClick={ onConfirm }
          />
        </div>
      </div>
    </>
  );
}